export const REQUIRED_ROLE_COPY =
  'The minimum Role a user must have<br />in order to access this source.'

export const KAPACITOR_TOOLTIP_COPY =
  '<p>Kapacitor Connections are<br/>scoped per InfluxDB Connection.<br/>Only one can be active at a time.</p>'

export enum DynamicSource {
  name = 'Dynamic Source',
  id = 'dynamic',
}
